import HotelStatusIcon from 'components/HotelStatusIcon'
import moment from 'moment'
import { Link } from 'react-router-dom'

import { Cell, Row } from '../../../../components/ReusableComponents/Table'
import useLocalStorage from '../../../../hooks/useLocalStorageState'
import { formatPrice } from '../../../../utils/common'
import CheckCell from '../../Common/CheckCell'
import HotelIdCell from '../../Common/HotelIdCell'
import HotelNameCell from '../../Common/HotelNameCell'
import styles from './PMSBErow.module.scss'

const DoubleCell = ({ primary, secondary, ...props }) => (
  <Cell className={styles.doubleCell} {...props}>
    <div className={styles.doubleCellPrimary}>{primary}</div>
    <div className={styles.doubleCellSecondary}>{secondary}</div>
  </Cell>
)

const GoToBillingAndPayments = ({ subsidiaryId }) => {
  return (
    <Link to={`/s/${subsidiaryId}/billing`}>
      <button>Go to Billing &amp; Payments →</button>
    </Link>
  )
}

const emailTypes = {
  SubsidiaryInvoiceForPayment: 'Payment',
  SubsidiaryInvoiceForReconciliation: 'Reconciliation',
  SubsidiaryInvoiceForPaymentLateMuch: 'Payment late'
}

const BillingRow = ({
  displayId,
  brand,
  shortName,
  isAutoPayEnabled,
  balanceCurrent,
  balanceLate,
  paymentLastReceivedOn,
  paymentLastAmount,
  emailLastContent,
  emailLastSentOn,
  subsidiaryId,
  index,
  subsidiaryStatus
}) => {
  const [note, setNote] = useLocalStorage(`healthCheck-billing-${subsidiaryId}`, '')

  return (
    <div className={styles.rowHolder}>
      <div className={styles.statusIcon}>
        <HotelStatusIcon status={subsidiaryStatus} />
      </div>
      <div className={styles.index}>{index}</div>
      <Row>
        <HotelIdCell displayId={displayId} />
        <HotelNameCell
          brand={brand}
          name={shortName}
          navigationControl={<GoToBillingAndPayments subsidiaryId={subsidiaryId} />}
        />
        <CheckCell isChecked={isAutoPayEnabled} />
        <Cell className={styles.textCell}>{formatPrice(balanceCurrent)}</Cell>
        <Cell className={styles.textCell}>{formatPrice(balanceLate)}</Cell>
        <DoubleCell primary={formatPrice(paymentLastAmount)} />
        <Cell className={styles.textCell}>
          {moment(paymentLastReceivedOn).format('MMM DD, YYYY')}
        </Cell>
        <DoubleCell
          primary={emailTypes[emailLastContent]}
          secondary={moment(emailLastSentOn).format('MMM DD, YYYY')}
        />
        <Cell className={styles.noteCell}>
          <input
            type="text"
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder=" "
          />
        </Cell>
      </Row>
    </div>
  )
}

export default BillingRow
